var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGcNotification(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.16406 6C5.16406 4.80653 5.63817 3.66193 6.48208 2.81802C7.326 1.97411 8.47059 1.5 9.66406 1.5C10.8575 1.5 12.0021 1.97411 12.846 2.81802C13.69 3.66193 14.1641 4.80653 14.1641 6C14.1641 11.25 16.4141 12.75 16.4141 12.75H2.91406C2.91406 12.75 5.16406 11.25 5.16406 6Z",
    stroke: "#67768E",
    strokeWidth: 1.16533,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39062 15.75C8.51616 15.9783 8.70071 16.1688 8.92499 16.3014C9.14928 16.434 9.40506 16.504 9.66562 16.504C9.92619 16.504 10.182 16.434 10.4063 16.3014C10.6305 16.1688 10.8151 15.9783 10.9406 15.75",
    stroke: "#67768E",
    strokeWidth: 1.16533,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66406 1.5C2.76406 2.775 2.16406 4.275 2.16406 6",
    stroke: "#67768E",
    strokeWidth: 1.16533,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1641 6C17.1641 4.275 16.5641 2.775 15.6641 1.5",
    stroke: "#67768E",
    strokeWidth: 1.16533,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcNotification);
export default __webpack_public_path__ + "static/media/GCNotification.f584833cd8f4db48fe26abc1fde6f865.svg";
export { ForwardRef as ReactComponent };